import actions from "./actions";
import { StanZadania } from "../../utils/stanZadania";
import { SentStateType } from "./sent.type";

const initialState: SentStateType = {
    deklaracje: [],
    pojazdy: [],
    // "idle" — zadanie jeszcze nie wyszlo. Bez tego stanu ekran pokazalby
    // "brak deklaracji" przy pierwszym renderowaniu, przed zapytaniem API.
    stanDeklaracji: "idle" as StanZadania,
    stanPojazdow: "idle" as StanZadania,
    zapis: false
};

export default function sentReducers(
    state = initialState,
    action: { payload: any; type: string }
): SentStateType {
    switch (action.type) {
        case actions.SET_SENT_DEKLARACJE:
            return { ...state, deklaracje: action.payload, stanDeklaracji: "ok" };
        case actions.SET_SENT_DEKLARACJE_LOADING:
            return { ...state, stanDeklaracji: "loading" };
        case actions.SET_SENT_DEKLARACJE_ERROR:
            return { ...state, stanDeklaracji: "error" };

        case actions.SET_SENT_POJAZDY:
            return { ...state, pojazdy: action.payload, stanPojazdow: "ok" };
        case actions.SET_SENT_POJAZDY_LOADING:
            return { ...state, stanPojazdow: "loading" };
        case actions.SET_SENT_POJAZDY_ERROR:
            return { ...state, stanPojazdow: "error" };

        case actions.SET_SENT_ZAPIS:
            return { ...state, zapis: action.payload };

        case actions.SET_INITIAL_SENT:
            return initialState;
        default:
            return state;
    }
}
